import { render } from "./AutoModal.vue?vue&type=template&id=2af26f9a&scoped=true"
import script from "./AutoModal.vue?vue&type=script&lang=js"
export * from "./AutoModal.vue?vue&type=script&lang=js"

import "./AutoModal.vue?vue&type=style&index=0&id=2af26f9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af26f9a"]])

export default __exports__